declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string;
        initDataUnsafe: { user?: { id: number; first_name: string; last_name?: string; username?: string; photo_url?: string } };
        colorScheme: 'light' | 'dark';
        platform: string;
        ready(): void;
        expand(): void;
        setHeaderColor?(color: string): void;
        setBackgroundColor?(color: string): void;
        onEvent?(name: string, cb: () => void): void;
        offEvent?(name: string, cb: () => void): void;
        HapticFeedback?: { impactOccurred(style: string): void; notificationOccurred(type: string): void };
      };
    };
  }
}

let sdkPromise: Promise<void> | null = null;

function telegramSurface() {
  return window.location.pathname.startsWith('/telegram');
}

function loadTelegramSdk() {
  if (!telegramSurface() || window.Telegram?.WebApp) return Promise.resolve();
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>('script[data-ef-telegram-sdk]');
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('Telegram SDK yuklanmadi.')), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-web-app.js?63';
    script.async = true;
    script.dataset.efTelegramSdk = 'true';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Telegram SDK yuklanmadi.'));
    document.head.appendChild(script);
  });

  return sdkPromise;
}

export const isTelegram = () => Boolean(window.Telegram?.WebApp?.initData);
export const telegramUser = () => window.Telegram?.WebApp?.initDataUnsafe?.user;

export async function initTelegram() {
  if (!telegramSurface()) return;
  try { await loadTelegramSdk(); } catch { return; }
  const app = window.Telegram?.WebApp;
  if (!app) return;
  app.ready();
  app.expand();
}

export function telegramTheme() {
  return window.Telegram?.WebApp?.colorScheme ?? null;
}

export function haptic(type: 'light' | 'medium' | 'heavy' = 'light') {
  try { window.Telegram?.WebApp?.HapticFeedback?.impactOccurred(type); } catch { /* no-op */ }
}
